export enum Au10TixWorkflowType {
  Au10tix201 = "Au10tix201",
  Au10tix202 = "Au10tix202",
  Au10tix203 = "Au10tix203",
  Au10tix204 = "Au10tix204",
  Au10tix205 = "Au10tix205",
  Au10tix206 = "Au10tix206",
  Au10tix207 = "Au10tix207",
}

export const Au10TixWorkflowTypeList = () =>
  Object.entries(Au10TixWorkflowType).map(([label, value]) => {
    return { label, value };
  });
